import React from "react";

import { t } from "i18next";

import KeyLayout from "components/Report/HelperComponents/KeyLayout";
import Subtitle from "components/Report/HelperComponents/Subtitle";
import TitleAlt from "components/Report/HelperComponents/TitleAlt";
import { TEST_NAME } from "constants/applicantReport";
import LineBreaker from "components/Report/HelperComponents/LineBreaker";

const Typing = ({ assessments }) => {
  const typingTestData = assessments.find(
    (assessment) => assessment?.name === TEST_NAME.TYPING_TEST
  );

  const data = {
    rawData: {
      score: typingTestData?.score?.raw_wpm,
      title: t("applicantReport.keyTest.rawWpm"),
    },
    accuracyData: typingTestData?.score?.accuracy_percentile,
    netData: {
      score: typingTestData?.score?.net_wpm,
      title: t("applicantReport.keyTest.netWordsPerMinute"),
    },
  };

  if (typingTestData?.status === "incomplete") {
    return null;
  }

  return (
    <>
      <LineBreaker />
      <TitleAlt>{t("applicantReport.typing")}</TitleAlt>
      <Subtitle>{t("applicantReport.measuresAperson")}</Subtitle>
      <KeyLayout data={data} />
    </>
  );
};

export default Typing;
